var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.ready)?_c('VideoComp',{attrs:{"x":972,"y":300,"src":_vm.video,"scale":1}}):_vm._e(),(_vm.ready && _vm.temporise)?_c('VideoComp',{attrs:{"x":10,"y":860,"src":_vm.video,"scale":1}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }